import * as angular from "angular";
import { DialogUtils } from "../../../../helper/dialog.helper";
import { ToastUtils } from "../../../../helper/toast.helper";
import { DashboardDataProvider } from "../../../../data-provider/dashboard.dp";
import { Group } from "../../../../models/group.model";
import { GroupDataProvider } from "../../../../data-provider/group.dp";
import { User } from "../../../../models/user.model";
import * as _ from "lodash";
import { Organisation } from "../../../../models/organisation.model";
import { CampaignDataProvider } from "../../../../data-provider/campaign.dp";
import { Division } from "../../../../models/division.model";
import { DivisionDataProvider } from "../../../../data-provider/division.dp";
import { Campaign } from "../../../../models/campaign.model";

let WidgetFilterDivisionsDialogComponent = {
    selector: "vcWidgetFilterDivisionsDialog",
    templateUrl:
        "/angular/components/dashboard/widget/filter/widget-filter-divisions-dialog.component.html",
    bindings: {
        filter: "=",
    },
    controller: class WidgetFilterDivisionsDialogController {
        // * bindings for typescript compiler *
        public filter: any;
        // ************************************
        public $scope: any;
        public saving: boolean = false;
        public dialog: DialogUtils;
        public toast: ToastUtils;
        public dataProvider: DashboardDataProvider;
        public campaignDataProvider: CampaignDataProvider;
        public divisionDataProvider: DivisionDataProvider;
        public type: string = "team";
        public groups: Group[];
        public organisation: Organisation;
        public divisions: Division[];

        constructor(
            $scope: any,
            DashboardDataProvider: DashboardDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            DivisionDataProvider: DivisionDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = DashboardDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.divisionDataProvider = DivisionDataProvider;
        }

        $onInit() {
            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.organisation = organisation;
                    this.organisation.checked = true;

                    this.divisionDataProvider
                        .getAllDivisions()
                        .then((divisions) => {
                            if (
                                this.filter.campaigns &&
                                this.filter.campaigns.length > 0
                            ) {
                                this.setCheckboxesBasedOnFilter(divisions);
                            } else {
                                this.setAllCheckboxes(divisions, true);
                            }
                            this.divisions = divisions;
                        });
                });

            this.$scope.$watch(
                () => this.divisions,
                (newValue: object, oldValue: object) => {
                    if (oldValue && newValue !== oldValue) {
                        let everyCampaignChecked = true;
                        let campaigns = [];
                        for (let i = 0; i < this.divisions.length; i++) {
                            let division = this.divisions[i];
                            let allChecked = true;
                            for (
                                let j = 0;
                                j < division.campaigns.length;
                                j++
                            ) {
                                if (division.campaigns[j].checked === true) {
                                    campaigns.push({
                                        campaignid:
                                            division.campaigns[j].campaignid,
                                        campaignname:
                                            division.campaigns[j].campaignname,
                                    });
                                } else {
                                    everyCampaignChecked = false;
                                    allChecked = false;
                                }
                            }
                            division.checked = allChecked;
                        }
                        if (everyCampaignChecked) {
                            this.filter.campaigns = [];
                        } else {
                            this.filter.campaigns = campaigns;
                        }
                    }
                },
                true
            );
        }

        buildFilter(division): void {
            let campaigns = division.campaigns;
            for (let j = 0; j < campaigns.length; j++) {
                campaigns[j].checked = division.checked;
            }
            this.organisation.checked =
                division.checked && this.checkDivisionCheckboxes();
        }

        selectAllCampaignsInDivision(division): void {
            let campaigns = division.campaigns;
            for (let j = 0; j < campaigns.length; j++) {
                campaigns[j].checked = division.checked;
            }
            this.organisation.checked =
                division.checked && this.checkDivisionCheckboxes();
        }

        checkDivisionCheckboxes(): boolean {
            let allSelected: boolean = true;
            for (let i = 0; i < this.divisions.length; i++) {
                if (!this.divisions[i].checked) {
                    allSelected = false;
                    break;
                }
            }
            return allSelected;
        }

        selectAll(): void {
            let checked = this.organisation.checked;
            this.setAllCheckboxes(this.divisions, checked);
        }

        setAllCheckboxes(divisions: Division[], checked: boolean): void {
            for (let i = 0; i < divisions.length; i++) {
                divisions[i].checked = checked;
                let campaigns = divisions[i].campaigns;
                for (let j = 0; j < campaigns.length; j++) {
                    campaigns[j].checked = checked;
                }
            }
        }

        setCheckboxesBasedOnFilter(divisions: Division[]): void {
            let everyCampaignChecked = true;
            for (let i = 0; i < divisions.length; i++) {
                let allChecked: boolean = true;
                for (let j = 0; j < divisions[i].campaigns.length; j++) {
                    if (
                        this.filter.campaigns.some((campaign) => {
                            return (
                                campaign.campaignid ===
                                divisions[i].campaigns[j].campaignid
                            );
                        })
                    ) {
                        divisions[i].campaigns[j].checked = true;
                    } else {
                        divisions[i].campaigns[j].checked = false;
                        allChecked = false;
                        everyCampaignChecked = false;
                    }
                }
                divisions[i].checked = allChecked;
            }
            this.organisation.checked = everyCampaignChecked;
        }

        cancel() {
            this.dialog.cancel();
        }

        save() {
            this.saving = true;
            this.dialog.hide(this.filter);
        }
    },
};

angular
    .module("dashboard")
    .component(
        WidgetFilterDivisionsDialogComponent.selector,
        WidgetFilterDivisionsDialogComponent
    );
